/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reset-resource.vue?vue&type=template&id=d2fee68a&scoped=true&"
import script from "./reset-resource.vue?vue&type=script&lang=ts&"
export * from "./reset-resource.vue?vue&type=script&lang=ts&"
import style0 from "./reset-resource.vue?vue&type=style&index=0&id=d2fee68a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fee68a",
  null
  
)

export default component.exports